import { Children, cloneElement, FC, ReactElement, ReactNode } from 'react';
import { cn } from '@fe-learner-common';

interface SkeletonProps {
  className?: string;
  type?: keyof typeof types;
}

export const PaginationSkeleton = () => {
  return (
    <div className="lf:flex lf:w-full lf:justify-between lf:pt-3">
      <Skeleton type="button" className="lf:h-[32px]" />

      <div className="lf:flex lf:items-center lf:gap-x-2">
        <Skeleton className="lf:h-[32px] lf:w-[32px] lf:rounded-lg" />
        <Skeleton className="lf:h-[32px] lf:w-[32px] lf:rounded-lg" />
        <Skeleton className="lf:h-[32px] lf:w-[32px] lf:rounded-lg" />
      </div>

      <Skeleton type="button" className="lf:h-[32px]" />
    </div>
  );
};

export const ListSkeleton = ({ noItems }: { noItems: number }) => {
  return (
    <div className="lf:flex lf:flex-col lf:gap-2">
      {[...Array(noItems || 8)].map((_, index) => (
        <Skeleton className="lf:h-[84px] lf:rounded-xl" key={index} type="row" />
      ))}
      <div className="lf:flex lf:justify-between">
        <Skeleton className="lf:h-8 " type="button" />
        <Skeleton className="lf:h-8 " type="button" />
      </div>
    </div>
  );
};

const types = {
  title: 'lf:w-[240px] lf:h-6 lf:rounded-xl',
  text: 'lf:w-[76px] lf:h-2 lf:rounded-xl',
  card: 'lf:aspect-video lf:rounded-xl',
  button: 'lf:w-[76px] lf:h-10 lf:rounded-lg',
  iconButton: 'lf:h-10 lf:w-10 lf:rounded-lg',
  row: 'lf:w-full lf:h-12',
};
export const Skeleton: FC<SkeletonProps> = ({ className, type }) => {
  return (
    <div
      className={cn(
        'lf:animate-pulse lf:bg-neutral-500',
        type && types[type],
        className,
      )}
    />
  );
};

interface SkeletonWrapperProps extends SkeletonProps {
  isLoading: boolean;
  skeletonClassName?: string;
  customSkeleton?: ReactNode;
  children: ReactNode;
}

export const SkeletonWrapper: FC<SkeletonWrapperProps> = ({
  children,
  isLoading,
  skeletonClassName,
  customSkeleton,
  ...rest
}) => {
  return isLoading
    ? customSkeleton || (
        <Skeleton
          {...rest}
          className={cn(rest?.className, skeletonClassName)}
        />
      )
    : Children.map(children, (child: ReactElement) => {
        return (
          child &&
          cloneElement(child, {
            ...rest,
            className: cn(rest?.className, child?.props?.className),
          })
        );
      });
};
